import {
  FormCol,
  FormRow,
  PhoneControl,
  TextControl,
} from 'ia-react-core';
import { FormSection } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledForm, StyledFormCol } from './EditPhoneSection.styles';

export interface EditPhoneSectionProps {
}

const EditPhoneSection: FC<EditPhoneSectionProps> = () => {
  const { t } = useTranslation('PersonalInformationsFormPage');
  const maxworkExtension = 4;

  return (
    <FormSection title={t('phones.title')} pb={12}>
      <FormRow>
        <FormCol label={t('phones.homePhoneLabel')}>
          <PhoneControl name="phones.home" required />
        </FormCol>
      </FormRow>
      <StyledForm label={t('phones.workPhoneLabel')}>
        <PhoneControl name="phones.work" />
      </StyledForm>
      <StyledFormCol label={t('phones.extentionPhoneLabel')}>
        <TextControl
          name="phones.workExtension"
          maxLength={maxworkExtension}
          validationMessages={{
            format: t('phones.extentionValidation'),
          }}
          validate={(value: string) => ({
            format: !value.match('^[0-9]*$'),
          })}
        />
      </StyledFormCol>
      <FormRow>
        <FormCol label={t('phones.cellPhoneLabel')}>
          <PhoneControl name="phones.cell" />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol label={t('phones.faxPhoneLabel')}>
          <PhoneControl name="phones.fax" />
        </FormCol>
      </FormRow>
    </FormSection>
  );
};

export default (EditPhoneSection);
